var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{staticClass:"table-responsive",attrs:{"items":_vm.evaluationsDates,"bordered":"","responsive":"","striped":"","thead-class":"d-none"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }